import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { EDMONTON_COMMUNITIES } from "@/data/communities";

/**
 * Mobile fallback for the trail map. Same tooltip content rendered as a
 * vertical list of cards.
 */
export const CommunityCardList = () => (
  <ul
    className="grid grid-cols-1 gap-4"
    data-testid="community-card-list"
  >
    {EDMONTON_COMMUNITIES.map((c, i) => (
      <Reveal key={c.slug} as="li" delay={i * 0.03}>
        <Link
          to={`/neighbourhoods/${c.slug}`}
          className="group block p-5"
          style={{
            borderRadius: 20,
            backgroundColor: "#F8F5EF",
            border: "1px solid rgba(32,30,26,0.08)",
          }}
          data-testid={`community-card-${c.slug}`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p
                className="font-display"
                style={{ fontSize: 22, color: "#201E1A", lineHeight: 1.1 }}
              >
                {c.name}
              </p>
              {c.formerly && (
                <p
                  className="mt-1 text-[11px] italic"
                  style={{ color: "rgba(32,30,26,0.5)" }}
                >
                  {c.formerly}
                </p>
              )}
            </div>
            <ArrowUpRight
              size={18}
              color="#24382E"
              className="mt-1 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </div>
          <p
            className="mt-3 text-[14px]"
            style={{ color: "rgba(32,30,26,0.72)" }}
          >
            {c.vibe}
          </p>
          <p
            className="label-caps mt-3 text-[10px]"
            style={{ color: "#C89A4E" }}
          >
            {c.rent}
          </p>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {c.bestFor.map((t) => (
              <span
                key={t}
                className="label-caps rounded-full px-2.5 py-1 text-[9px]"
                style={{ backgroundColor: "#E4DFD3", color: "#24382E" }}
              >
                {t}
              </span>
            ))}
          </div>
        </Link>
      </Reveal>
    ))}
  </ul>
);

export default CommunityCardList;
